import { Field, Checkbox } from '@zendeskgarden/react-forms';
import type { PropsCheckbox } from './interface';

export function Checkboxs({ items }: PropsCheckbox) {
  return (
    <Field>
      <Checkbox 
        checked={items.checked}
        onChange={(e) => items.onChange(e.target.checked)}
      >
        <Field.Label className="text-green-800 text-xs font-semibold">{items.title}</Field.Label>
      </Checkbox>
    </Field>
  );
}